import * as React from "react";
import {
  CardDescription,
  UsernameCardWrapper,
} from "src/components/shared/Cards/Cards.components";
import {
  SummaryBar,
  SummaryBarWrapper,
  SummaryCardElement,
} from "src/components/shared/Cards/SummaryCard/SummaryCard.components";
interface Props {
  numOfVotes: number;
  value: string;
  totalNumOfVotes: number;
  isGreatest?: boolean;
}

const SummaryCard: React.FunctionComponent<Props> = ({
  numOfVotes,
  value,
  totalNumOfVotes,
  isGreatest,
}) => {
  return (
    <UsernameCardWrapper isSummary>
      <SummaryCardElement data-cy="summaryCard" isGreatest={isGreatest}>
        {value}
      </SummaryCardElement>
      <SummaryBarWrapper>
        <CardDescription>
          {`${numOfVotes} vote${numOfVotes !== 1 ? "s" : ""}`}
        </CardDescription>
        <SummaryBar
          percentage={(numOfVotes / totalNumOfVotes) * 100}
          isGreatest={isGreatest}
        />
      </SummaryBarWrapper>
    </UsernameCardWrapper>
  );
};

export default SummaryCard;
